<template>
  <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.98096 12.6C9.46617 12.6 10.8906 12.01 11.9408 10.9598C12.991 9.90959 13.581 8.48521 13.581 7C13.581 5.51479 12.991 4.09041 11.9408 3.0402C10.8906 1.99 9.46617 1.4 7.98096 1.4C6.49574 1.4 5.07136 1.99 4.02116 3.0402C2.97096 4.09041 2.38096 5.51479 2.38096 7C2.38096 8.48521 2.97096 9.90959 4.02116 10.9598C5.07136 12.01 6.49574 12.6 7.98096 12.6ZM7.98096 0C8.90021 0 9.81046 0.18106 10.6597 0.532843C11.509 0.884626 12.2807 1.40024 12.9307 2.05025C13.5807 2.70026 14.0963 3.47194 14.4481 4.32122C14.7999 5.17049 14.981 6.08075 14.981 7C14.981 8.85651 14.2435 10.637 12.9307 11.9497C11.6179 13.2625 9.83747 14 7.98096 14C4.10996 14 0.980957 10.85 0.980957 7C0.980957 5.14348 1.71845 3.36301 3.03121 2.05025C4.34396 0.737498 6.12444 0 7.98096 0ZM8.33096 3.5V7.175L11.481 9.044L10.956 9.905L7.28096 7.7V3.5H8.33096Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>